export const en = {
  dir: "ltr",
  locale: "en",
  common: {
    appName: "Madar Manhom",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    create: "Create",
    confirm: "Confirm",
    loading: "Loading...",
    admin: "ADMIN",
    user: "USER",
  },
  nav: {
    dashboard: "Dashboard",
    users: "Users",
    editor: "Editor",
    documents: "Documents",
    mappings: "Mappings",
    grammarRules: "Grammar Rules",
    settings: "Settings",
  },
  editor: {
    title: "AI Article Editor",
    input: "Input Article",
    output: "AI Result",
    process: "Process with AI",
    save: "Save",
    selectPrompt: "Prompt",
    selectProvider: "AI Provider",
    processing: "Processing...",
    saved: "Saved successfully",
    error: "Something went wrong. Please try again.",
  },
  workbench: {
    title: "Article Workbench",
    source: "English Source",
    arabic: "Arabic Article",
    step1: "Replace",
    step2: "Translate",
    step3: "Review",
    step4: "Title",
    replace: "Replace Words",
    translate: "Translate",
    check: "Check Grammar",
    generateTitles: "Generate Titles",
    regenerate: "Regenerate",
    accept: "Accept",
    reject: "Reject",
    noIssues: "No issues",
    noIssuesLong: "No issues found — looks great!",
    save: "Save Document",
    saved: "Saved",
    error: "Something went wrong. Please try again.",
    issues: "issues",
    allSuggestions: "All suggestions",
    closeDrawer: "Close",
    freeEditHint: "Review resolved — you can now edit freely",
    outOfSync: "Suggestion out of sync — re-run check",
    titlesPlaceholder: "Click Generate Titles below to get 5 suggestions",
    arabicEmpty: "Translate your source text to start editing here",
    sourceHeading: "Source",
    collapse: "Collapse",
    expand: "Expand",
    englishOriginal: "English Original",
    englishReplaced: "English Replaced",
    arabicResult: "Arabic Result",
    noTitlesYet: "Generated titles will appear here",
    approve: "Approve",
    keep: "Keep",
    kept: "kept",
    undo: "Undo",
    restore: "Restore",
    approveAll: "Approve All",
    exitReview: "Exit Review",
    pending: "pending",
    approved: "approved",
    rejected: "rejected",
    formattingSimplified: "Formatting simplified after review — re-apply as needed",
    backToEdit: "Back to edit",
    translated: "Translated",
    replaced: "Replaced",
    reviewed: "Reviewed",
  },
  wizard: {
    stepEnglish: "English",
    stepReplace: "Replace",
    stepTranslate: "Translate",
    stepReview: "Review",
    stepTitle: "Title",
    headingEnglish: "Original English Text",
    headingReplace: "Replace Words",
    headingTranslate: "Translation",
    headingReview: "Grammar Review",
    headingTitle: "Title & Save",
    nextReplace: "Next: Replace Words",
    nextTranslate: "Next: Translate",
    nextReview: "Next: Review",
    nextTitle: "Next: Title",
    back: "Back",
    replacing: "Replacing words...",
    translating: "Translating...",
    checking: "Checking grammar...",
    generatingTitles: "Generating titles...",
    beforeLabel: "Before",
    afterLabel: "After",
    wordsReplaced: "words replaced",
    noErrors: "No errors found",
    enterTextFirst: "Enter English text first",
    resetWarning: "Re-running this step will reset subsequent steps",
    changelogTitle: "Change Log",
    logEnglish: "English text entered",
    logReplaced: "Words replaced",
    logWordsReplaced: "words replaced",
    logTranslated: "Translated via DeepL",
    logReviewed: "Grammar reviewed",
    logNoErrors: "No errors found",
    logSaved: "Document saved",
    logTitleChosen: "Title",
    logCharacters: "characters",
    logStep1: "English text entered",
    logStep2: "Words replaced",
    logStep3: "Translated via DeepL",
    logStep4: "Grammar reviewed",
    logStep5: "Title & save",
    checkGrammar: "Check Grammar",
    saveDocument: "Save Document",
    next: "Next",
  },
  pipeline: {
    step1Title: "English Article",
    step1Button: "Replace Words",
    step1Result: "Replaced text",
    step2Title: "Translate (DeepL)",
    step2Button: "Translate with DeepL",
    step3Title: "Arabic Review",
    step3Button: "Check Grammar",
    step3NoIssues: "No suggestions. Looks good!",
    step3Accept: "Accept",
    step3Reject: "Reject",
    step4Title: "Generate Title",
    step4Button: "Generate Titles",
    step4Regenerate: "Regenerate",
    step4Placeholder: "Final title",
    save: "Save Document",
    saved: "Saved",
    errorRunStep1: "Run Step 1 first",
  },
  documents: {
    title: "My Documents",
    empty: "No documents yet.",
    newDocument: "New document",
  },
  header: {
    logout: "Logout",
    adminPanel: "Admin Panel",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome back to the admin panel.",
    currentUser: "Current user",
    name: "Name",
    email: "Email",
    role: "Role",
  },
  users: {
    title: "Users",
    subtitle: "Manage user accounts and roles.",
    name: "Name",
    email: "Email",
    role: "Role",
    password: "Password",
    created: "Created",
    actions: "Actions",
    noUsers: "No users found.",
    addUser: "New user",
    editUser: "Edit user",
    createUser: "Create user",
    deleteUser: "Delete user",
    deleteConfirm: "Are you sure you want to delete this user?",
    passwordKeep: "Leave blank to keep current password",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
  },
  mappings: {
    title: "Word Mappings",
    subtitle: "Manage the EN to AR substitution dictionary.",
    english: "English",
    arabic: "Arabic",
    active: "Active",
    actions: "Actions",
    new: "New mapping",
    edit: "Edit mapping",
    delete: "Delete mapping",
    deleteConfirm: "Are you sure you want to delete this mapping?",
    noMappings: "No mappings yet.",
    duplicateError: "This English word already exists.",
    save: "Save",
    cancel: "Cancel",
  },
  grammarRules: {
    title: "Grammar Rules",
    subtitle: "Manage regex-based grammar correction rules.",
    name: "Name",
    description: "Description",
    reason: "Reason",
    pattern: "Pattern",
    replacement: "Replacement",
    flags: "Flags",
    enabled: "Enabled",
    sortOrder: "Order",
    actions: "Actions",
    new: "New Rule",
    edit: "Edit Rule",
    delete: "Delete Rule",
    deleteConfirm: "Are you sure you want to delete the rule \"{name}\"?",
    noRules: "No grammar rules yet.",
    save: "Save",
    cancel: "Cancel",
    invalidRegex: "Invalid regular expression",
    reasonHelp: "Supports {{from}}, {{to}}, {{$1}} placeholders.",
    patternHelp: "Regex source without delimiters (e.g. \\bfoo\\b).",
    aiGenerate: "Generate with AI",
    aiPromptPlaceholder: "Describe the rule...",
    aiExampleInput: "Example input",
    aiExampleOutput: "Example output",
    generating: "Generating...",
    testTitle: "Test Rule",
    testPlaceholder: "Enter test text...",
    runTest: "Run Test",
    noMatches: "No matches found",
    matchesFound: "matches found",
    backToList: "Back to rules",
    createRule: "Create Rule",
    updateRule: "Update Rule",
  },
  settings: {
    title: "Settings",
    subtitle: "Configure AI providers, translation, and prompt templates.",
    tabs: {
      providers: "AI Providers",
      deepl: "Translation",
      grammar: "Grammar Review",
      titles: "Title Generator",
    },
    save: "Save",
    saving: "Saving...",
    saved: "Saved",
    activeProvider: "Active Provider",
    apiKey: "API Key",
    apiKeyFilled: "Filled",
    apiKeyPlaceholder: "Enter API key",
    apiKeyKeep: "Leave blank to keep current",
    currentKey: "Current key",
    model: "Model",
    baseUrl: "Base URL (optional)",
    providersSectionTitle: "AI Providers",
    providersSectionSubtitle: "Choose the active provider and configure credentials for each.",
    grammarMode: "Grammar Mode",
    grammarModeRegex: "Regex Engine (recommended)",
    grammarModeAi: "AI Provider",
    grammarModeDesc: "Regex — instant, deterministic, 100% rule-compliant (tashkeel/tanween/punctuation only).\nAI — uses the active AI provider with the prompt below (flexible but may hallucinate).",
    grammarSectionTitle: "Grammar Review",
    grammarSectionSubtitle: "Choose the grammar checking engine and configure rules.",
    titlesSectionTitle: "Title Generator",
    titlesSectionSubtitle: "Rules and prompt template used to generate Arabic title suggestions.",
    titleRules: "Title Rules",
    titleRulesHelp: "Free-form rules injected into the title prompt.",
    arabicRulesHelp: "Free-form rules injected into the grammar prompt.",
    grammarPromptHelp: "Use {{grammar_rules}} and {{text}} placeholders in the prompt template.",
    titlePromptHelp: "Use {{title_rules}} and {{text}} placeholders.",
    deepl: {
      title: "DeepL Translation",
      subtitle: "Configure DeepL for English-to-Arabic translation.",
      apiKey: "API Key",
      plan: "Plan",
      planFree: "Free",
      planPro: "Pro",
      sourceLang: "Source Language",
      targetLang: "Target Language",
    },
    arabicRules: "Arabic Rules",
    grammarPrompt: "Grammar Prompt",
    titlePrompt: "Title Prompt",
  },
  adminSettings: {
    title: "Admin Settings",
    subtitle: "Manage AI providers, prompts, and view documents.",
    tabProviders: "Providers",
    tabPrompts: "Prompts",
    tabDocuments: "Documents",
    providers: {
      title: "AI Providers",
      add: "New provider",
      edit: "Edit provider",
      create: "Create provider",
      delete: "Delete provider",
      deleteConfirm: "Are you sure you want to delete this provider?",
      none: "No providers configured.",
      name: "Name",
      type: "Type",
      apiKey: "API key",
      apiKeyKeep: "Leave blank to keep current key",
      modelName: "Model name",
      baseUrl: "Base URL",
      isActive: "Active",
      isDefault: "Default",
      created: "Created",
      actions: "Actions",
    },
    prompts: {
      title: "Prompts",
      add: "New prompt",
      edit: "Edit prompt",
      create: "Create prompt",
      delete: "Delete prompt",
      deleteConfirm: "Are you sure you want to delete this prompt?",
      none: "No prompts configured.",
      name: "Name",
      content: "Content",
      isDefault: "Default",
      created: "Created",
      actions: "Actions",
    },
    documents: {
      title: "Documents",
      none: "No documents yet.",
      id: "ID",
      user: "User",
      status: "Status",
      created: "Created",
      updated: "Updated",
    },
  },
  auth: {
    welcomeBack: "Welcome back",
    signInSubtitle: "Sign in to your account to continue",
    emailLabel: "Email",
    emailPlaceholder: "you@example.com",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    protectedArea: "Protected area. Authorized personnel only.",
    adminDashboard: "Admin Dashboard",
    brandDescription: "Manage your platform with powerful tools and real-time insights.",
    feature1: "Real-time analytics and reporting",
    feature2: "Secure access control",
    feature3: "Streamlined operations",
    invalidCredentials: "Invalid email or password",
    somethingWrong: "Something went wrong. Please try again.",
  },
};

type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>;
};

export type Translations = DeepStringify<typeof en>;
